import type {
  PortfolioRequest,
  PortfolioResponse,
  PortfolioTagsResponse,
  PortfolioWalletRequest,
} from './models/PortfolioModels';

import { httpService } from '../services/httpService';

export async function getPortfolio(
  wallets: PortfolioWalletRequest[],
  signal?: AbortSignal,
): Promise<PortfolioResponse> {
  const body: PortfolioRequest = { wallets };
  const response = await httpService.post<PortfolioResponse>('/portfolio/details', body, {
    signal,
  });
  return response.data;
}

export async function listPortfolioTags(signal?: AbortSignal): Promise<PortfolioTagsResponse> {
  const response = await httpService.get<PortfolioTagsResponse>('/portfolio/tags', { signal });
  return response.data;
}
